/**
 * Score level for analysis output.
 * Evidence: addin-webview/src/app/shared/models/score-level.ts (identical in both apps)
 */
export type ScoreLevel = 'l1' | 'l2' | 'l3' | 'l4';

export const ScoreLevelHelper = {
  fromScore(score: unknown): ScoreLevel {
    const s = Number(score);
    if (!Number.isFinite(s) || s <= 1) return 'l1';
    if (s <= 4) return 'l2';
    if (s <= 7) return 'l3';
    return 'l4';
  },
};
